import { DefaultError } from 'errors/DefaultError';

export class MeterReadMaxAttemptsError extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: MeterReadMaxAttemptsError.name,
      title: 'Talk to us about your move',
      message: ''
    });
  }

  static get name() {
    return 'MeterReadMaxAttemptsError';
  }
}

export class MeterReadAgentHandOffError extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: MeterReadAgentHandOffError.name,
      title: 'Talk to us about your move',
      message: ''
    });
  }

  static get name() {
    return 'MeterReadAgentHandOffError';
  }
}

export class MeterReadTolleranceError extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: MeterReadTolleranceError.name,
      title: 'Your readings are different to what we expected',
      message: ''
    });
  }
  static get name() {
    return 'MeterReadTolleranceError';
  }
}
